module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.1e6ecd20.mp3";